import { createSvgIcon } from '@mui/material/utils';

// MUI's SettingsRemote icon path plus a diagonal stripe matching the style
// LayersClear uses to convey a "disabled / locked" state.
export const SettingsRemoteOff = createSvgIcon(
  <>
    <path d="M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1m-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2M7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05M12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0" />
    <path d="M3.27 1 2 2.27 21.73 22 23 20.73Z" />
  </>,
  'SettingsRemoteOff',
);
